import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import GeneralInfoContainer from './components/GeneralInfoContainer';
import GeneralInfoLine from './components/GeneralInfoLine';
import Title from '../Title';

import connect from './connect';
import messages from '../../messages';

const GeneralInfo = ({
  address,
  billingInfo,
  bromatologyCode,
  intl: { formatMessage },
}) => {
  const { companyName, companyNumber } = billingInfo;
  const { street, doorNumber } = address;

  return (
    <>
      <GeneralInfoContainer>
        <Title> {formatMessage(messages.generalInfoTitle)}</Title>
        {street && doorNumber && (
          <GeneralInfoLine>
            {formatMessage(messages.generalInfoCompanyAddress, {
              street,
              doorNumber,
            })}
          </GeneralInfoLine>
        )}
        {companyName && (
          <GeneralInfoLine>
            {formatMessage(messages.generalInfoTitleCompanyName, {
              companyName,
            })}
          </GeneralInfoLine>
        )}
        {companyNumber && (
          <GeneralInfoLine>
            {formatMessage(messages.generalInfoCompanyNumber, {
              companyNumber,
            })}
          </GeneralInfoLine>
        )}
        {bromatologyCode && (
          <GeneralInfoLine>
            {formatMessage(messages.generalInfoBromatologyCode, {
              bromatologyCode,
            })}
          </GeneralInfoLine>
        )}
      </GeneralInfoContainer>
    </>
  );
};

GeneralInfo.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    doorNumber: PropTypes.string,
  }).isRequired,
  billingInfo: PropTypes.shape({
    companyName: PropTypes.string,
    companyNumber: PropTypes.string,
  }).isRequired,
  bromatologyCode: PropTypes.string,
  intl: intlShape.isRequired,
};

export default connect(GeneralInfo);
